// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Admin global styles — stage-1 visual pass (2026-10-12).
  All AntD-wide tweaks live here so every screen inherits the design
  language without per-screen edits. Component tokens that AntD exposes
  (card radius, button radius, menu pill, table header bg) are set in
  ConfigProvider in main.tsx; this file covers what tokens don't cover
  or where a direct selector is clearer.
*/

/* --- Shared design tokens (CSS variables) --------------------------------- */
:root {
  --app-purple:       #8B2FD6;
  --app-purple-deep:  #6B21A8;
  --app-lavender:     #F1EAFF;    /* page bg + table header */
  --app-lavender-alt: #EFE9FA;    /* menu active bg + chip */
  --app-mint:         #4CE0A8;    /* success chip / "on" switch */
  --app-mint-soft:    #E7FBF2;    /* mint chip bg */
  --app-danger-soft:  #FFECEC;    /* soft red button bg */
  --app-ink:          #22174B;
  --app-ink-muted:    #6D6386;
}

/* --- Card: large radius + soft diffuse shadow ----------------------------- */
.ant-card {
  border-radius: 16px;
  border: 0;
  box-shadow:
    0 2px 8px   rgba(107, 33, 168, 0.05),
    0 8px 24px  rgba(107, 33, 168, 0.08);
  overflow: hidden;
}
.ant-card > .ant-card-head {
  border-bottom: 1px solid rgba(107, 33, 168, 0.08);
  padding: 0 20px;
  min-height: 56px;
}
.ant-card > .ant-card-head .ant-card-head-title {
  padding: 14px 0;
  font-weight: 700;
  font-size: 16px;
  color: var(--app-ink);
}
.ant-card > .ant-card-body {
  padding: 20px;
}

/* --- Table: light-purple header + roomier rows ---------------------------- */
.ant-table-thead > tr > th.ant-table-cell {
  background: var(--app-lavender) !important;
  color: var(--app-purple-deep);
  font-weight: 600;
}
.ant-table-tbody > tr > td.ant-table-cell {
  padding-top: 14px;
  padding-bottom: 14px;
}

/* --- Menu (sidebar): rounded pill for active item ------------------------- */
/* Theme tokens already set itemBorderRadius + itemSelectedBg; these just
   polish the margins so the pill breathes correctly inside the Sider. */
.ant-menu-inline .ant-menu-item {
  margin-inline: 10px !important;
  width: calc(100% - 20px) !important;
  height: 44px !important;
  line-height: 44px !important;
  font-weight: 500;
}

/* --- Switch: mint-green when checked -------------------------------------- */
.ant-switch.ant-switch-checked {
  background: var(--app-mint) !important;
}
.ant-switch.ant-switch-checked:hover:not(.ant-switch-disabled) {
  background: #35caa0 !important;
}

/* --- Chip helpers (plain classes, used by the LessonPage) ----------------- */
.chip-mint {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--app-mint-soft);
  color: #0a7a52;
  padding: 4px 12px;
  border-radius: 999px;
  font-weight: 600;
  font-size: 13px;
  line-height: 1.3;
  border: 1px solid rgba(76, 224, 168, 0.3);
}
.chip-lavender {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--app-lavender-alt);
  color: var(--app-purple-deep);
  padding: 4px 12px;
  border-radius: 999px;
  font-weight: 500;
  font-size: 13px;
  line-height: 1.3;
}

/* --- Small-screen blocker ------------------------------------------------
   Hidden by default on desktop. Below 800px the fixed overlay covers the
   entire app (login, header, sidebar, modals) and blocks interaction. */
.admin-small-screen-blocker { display: none; }
@media (max-width: 799px) {
  .admin-small-screen-blocker {
    position: fixed;
    inset: 0;
    /* Above the sticky header (z-index 100) and above AntD Modal
       (default 1000), Message (2010), and Notification (2050). */
    z-index: 3000;
    background: var(--app-lavender);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    direction: rtl;
  }
  .admin-small-screen-blocker__card {
    max-width: 400px;
    width: 100%;
    background: #ffffff;
    border-radius: 16px;
    padding: 32px 24px;
    text-align: center;
    box-shadow:
      0 10px 40px rgba(107, 33, 168, 0.14),
      0 2px 8px   rgba(34, 23, 75, 0.06);
  }
  .admin-small-screen-blocker__icon {
    font-size: 48px;
    color: var(--app-purple);
    margin-bottom: 16px;
    display: inline-block;
  }
  .admin-small-screen-blocker__title {
    margin: 0 0 8px;
    font-size: 22px;
    font-weight: 700;
    color: var(--app-purple);
    line-height: 1.3;
  }
  .admin-small-screen-blocker__body {
    margin: 0;
    font-size: 15px;
    color: var(--app-ink-muted);
    line-height: 1.6;
  }
}

/* --- Dashboard list rows (grades card linking to /grades/:id) ------------
   Shared by any list where the whole row is a <Link> styled flat. Hover
   gets the same lavender wash the menu items use so the affordance is
   consistent across the panel. */
.dash-row:hover {
  background: var(--app-lavender-alt);
}

/* --- Login screen segmented 6-digit code input --------------------------- */
.login-otp {
  display: inline-flex;
  gap: 10px;
  direction: ltr;    /* digits read LTR inside their boxes */
}
.login-otp input {
  width: 46px;
  height: 56px;
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  color: var(--app-ink);
  background: #F8F5FF;
  border: 1.5px solid #DCD4EC;
  border-radius: 10px;
  outline: none;
  caret-color: var(--app-purple);
  transition: border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;
}
.login-otp input:focus {
  border-color: var(--app-purple);
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(139, 47, 214, 0.12);
}
.login-otp input:disabled {
  background: #F3EEF9;
  color: #8c8c8c;
  cursor: not-allowed;
}

/* --- Page-level action buttons (taller, more padded) ---------------------
   Only in two slots: a Card's \`extra\` and the PageHeader's actions row —
   this is where "page-level" primary actions live. \`size="small"\` buttons
   and our \`.btn-action-round\` icon buttons stay compact so inline table
   buttons, pagination (lives outside \`.ant-card-extra\`), and secondary
   small controls are NOT inflated. Height 44 px / padding 20 px / font
   15 px matches the mockup's chunky pill feel. */
.ant-card-head .ant-card-extra .ant-btn:not(.ant-btn-sm):not(.btn-action-round),
.admin-page-header .ant-btn:not(.ant-btn-sm):not(.btn-action-round) {
  height: 44px;
  padding: 0 20px;
  font-size: 15px;
}
.ant-card-head .ant-card-extra .ant-btn:not(.ant-btn-sm):not(.btn-action-round) .anticon,
.admin-page-header .ant-btn:not(.ant-btn-sm):not(.btn-action-round) .anticon {
  font-size: 16px;
}

/* --- Icon-only action buttons (rounded square) ---------------------------- */
.ant-btn.btn-action-round {
  width: 32px;
  height: 32px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px !important;
}
.ant-btn.btn-action-round.btn-action-danger {
  color: #d4380d;
  background: var(--app-danger-soft);
  border-color: transparent;
}
.ant-btn.btn-action-round.btn-action-danger:hover {
  color: #a8071a;
  background: #ffd6d6;
}
`, "",{"version":3,"sources":["webpack://./src/theme/global.css"],"names":[],"mappings":"AAAA;;;;;;;CAOC;;AAED,+EAA+E;AAC/E;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B,KAAK,2BAA2B;EAC3D,2BAA2B,KAAK,0BAA0B;EAC1D,2BAA2B,KAAK,+BAA+B;EAC/D,2BAA2B,KAAK,iBAAiB;EACjD,2BAA2B,KAAK,uBAAuB;EACvD,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,+EAA+E;AAC/E;EACE,mBAAmB;EACnB,SAAS;EACT;;wCAEsC;EACtC,gBAAgB;AAClB;AACA;EACE,iDAAiD;EACjD,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;;AAEA,+EAA+E;AAC/E;EACE,0CAA0C;EAC1C,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,+EAA+E;AAC/E;wEACwE;AACxE;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,+EAA+E;AAC/E;EACE,sCAAsC;AACxC;AACA;EACE,8BAA8B;AAChC;;AAEA,+EAA+E;AAC/E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,6BAA6B;EAC7B,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;wEAEwE;AACxE,8BAA8B,aAAa,EAAE;AAC7C;EACE;IACE,eAAe;IACf,QAAQ;IACR;iEAC6D;IAC7D,aAAa;IACb,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB;;wCAEoC;EACtC;EACA;IACE,eAAe;IACf,wBAAwB;IACxB,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;EAClB;AACF;;AAEA;;;iCAGiC;AACjC;EACE,mCAAmC;AACrC;;AAEA,8EAA8E;AAC9E;EACE,oBAAoB;EACpB,SAAS;EACT,cAAc,KAAK,uCAAuC;AAC5D;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,iFAAiF;AACnF;AACA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;;;;iDAMiD;AACjD;;EAEE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;;AAEA,+EAA+E;AAC/E;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,kCAAkC;EAClC,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,mBAAmB;AACrB","sourcesContent":["/*\n  Admin global styles — stage-1 visual pass (2026-10-12).\n  All AntD-wide tweaks live here so every screen inherits the design\n  language without per-screen edits. Component tokens that AntD exposes\n  (card radius, button radius, menu pill, table header bg) are set in\n  ConfigProvider in main.tsx; this file covers what tokens don't cover\n  or where a direct selector is clearer.\n*/\n\n/* --- Shared design tokens (CSS variables) --------------------------------- */\n:root {\n  --app-purple:       #8B2FD6;\n  --app-purple-deep:  #6B21A8;\n  --app-lavender:     #F1EAFF;    /* page bg + table header */\n  --app-lavender-alt: #EFE9FA;    /* menu active bg + chip */\n  --app-mint:         #4CE0A8;    /* success chip / \"on\" switch */\n  --app-mint-soft:    #E7FBF2;    /* mint chip bg */\n  --app-danger-soft:  #FFECEC;    /* soft red button bg */\n  --app-ink:          #22174B;\n  --app-ink-muted:    #6D6386;\n}\n\n/* --- Card: large radius + soft diffuse shadow ----------------------------- */\n.ant-card {\n  border-radius: 16px;\n  border: 0;\n  box-shadow:\n    0 2px 8px   rgba(107, 33, 168, 0.05),\n    0 8px 24px  rgba(107, 33, 168, 0.08);\n  overflow: hidden;\n}\n.ant-card > .ant-card-head {\n  border-bottom: 1px solid rgba(107, 33, 168, 0.08);\n  padding: 0 20px;\n  min-height: 56px;\n}\n.ant-card > .ant-card-head .ant-card-head-title {\n  padding: 14px 0;\n  font-weight: 700;\n  font-size: 16px;\n  color: var(--app-ink);\n}\n.ant-card > .ant-card-body {\n  padding: 20px;\n}\n\n/* --- Table: light-purple header + roomier rows ---------------------------- */\n.ant-table-thead > tr > th.ant-table-cell {\n  background: var(--app-lavender) !important;\n  color: var(--app-purple-deep);\n  font-weight: 600;\n}\n.ant-table-tbody > tr > td.ant-table-cell {\n  padding-top: 14px;\n  padding-bottom: 14px;\n}\n\n/* --- Menu (sidebar): rounded pill for active item ------------------------- */\n/* Theme tokens already set itemBorderRadius + itemSelectedBg; these just\n   polish the margins so the pill breathes correctly inside the Sider. */\n.ant-menu-inline .ant-menu-item {\n  margin-inline: 10px !important;\n  width: calc(100% - 20px) !important;\n  height: 44px !important;\n  line-height: 44px !important;\n  font-weight: 500;\n}\n\n/* --- Switch: mint-green when checked -------------------------------------- */\n.ant-switch.ant-switch-checked {\n  background: var(--app-mint) !important;\n}\n.ant-switch.ant-switch-checked:hover:not(.ant-switch-disabled) {\n  background: #35caa0 !important;\n}\n\n/* --- Chip helpers (plain classes, used by the LessonPage) ----------------- */\n.chip-mint {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--app-mint-soft);\n  color: #0a7a52;\n  padding: 4px 12px;\n  border-radius: 999px;\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 1.3;\n  border: 1px solid rgba(76, 224, 168, 0.3);\n}\n.chip-lavender {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--app-lavender-alt);\n  color: var(--app-purple-deep);\n  padding: 4px 12px;\n  border-radius: 999px;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 1.3;\n}\n\n/* --- Small-screen blocker ------------------------------------------------\n   Hidden by default on desktop. Below 800px the fixed overlay covers the\n   entire app (login, header, sidebar, modals) and blocks interaction. */\n.admin-small-screen-blocker { display: none; }\n@media (max-width: 799px) {\n  .admin-small-screen-blocker {\n    position: fixed;\n    inset: 0;\n    /* Above the sticky header (z-index 100) and above AntD Modal\n       (default 1000), Message (2010), and Notification (2050). */\n    z-index: 3000;\n    background: var(--app-lavender);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 24px;\n    direction: rtl;\n  }\n  .admin-small-screen-blocker__card {\n    max-width: 400px;\n    width: 100%;\n    background: #ffffff;\n    border-radius: 16px;\n    padding: 32px 24px;\n    text-align: center;\n    box-shadow:\n      0 10px 40px rgba(107, 33, 168, 0.14),\n      0 2px 8px   rgba(34, 23, 75, 0.06);\n  }\n  .admin-small-screen-blocker__icon {\n    font-size: 48px;\n    color: var(--app-purple);\n    margin-bottom: 16px;\n    display: inline-block;\n  }\n  .admin-small-screen-blocker__title {\n    margin: 0 0 8px;\n    font-size: 22px;\n    font-weight: 700;\n    color: var(--app-purple);\n    line-height: 1.3;\n  }\n  .admin-small-screen-blocker__body {\n    margin: 0;\n    font-size: 15px;\n    color: var(--app-ink-muted);\n    line-height: 1.6;\n  }\n}\n\n/* --- Dashboard list rows (grades card linking to /grades/:id) ------------\n   Shared by any list where the whole row is a <Link> styled flat. Hover\n   gets the same lavender wash the menu items use so the affordance is\n   consistent across the panel. */\n.dash-row:hover {\n  background: var(--app-lavender-alt);\n}\n\n/* --- Login screen segmented 6-digit code input --------------------------- */\n.login-otp {\n  display: inline-flex;\n  gap: 10px;\n  direction: ltr;    /* digits read LTR inside their boxes */\n}\n.login-otp input {\n  width: 46px;\n  height: 56px;\n  text-align: center;\n  font-size: 24px;\n  font-weight: 600;\n  color: var(--app-ink);\n  background: #F8F5FF;\n  border: 1.5px solid #DCD4EC;\n  border-radius: 10px;\n  outline: none;\n  caret-color: var(--app-purple);\n  transition: border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;\n}\n.login-otp input:focus {\n  border-color: var(--app-purple);\n  background: #ffffff;\n  box-shadow: 0 0 0 4px rgba(139, 47, 214, 0.12);\n}\n.login-otp input:disabled {\n  background: #F3EEF9;\n  color: #8c8c8c;\n  cursor: not-allowed;\n}\n\n/* --- Page-level action buttons (taller, more padded) ---------------------\n   Only in two slots: a Card's `extra` and the PageHeader's actions row —\n   this is where \"page-level\" primary actions live. `size=\"small\"` buttons\n   and our `.btn-action-round` icon buttons stay compact so inline table\n   buttons, pagination (lives outside `.ant-card-extra`), and secondary\n   small controls are NOT inflated. Height 44 px / padding 20 px / font\n   15 px matches the mockup's chunky pill feel. */\n.ant-card-head .ant-card-extra .ant-btn:not(.ant-btn-sm):not(.btn-action-round),\n.admin-page-header .ant-btn:not(.ant-btn-sm):not(.btn-action-round) {\n  height: 44px;\n  padding: 0 20px;\n  font-size: 15px;\n}\n.ant-card-head .ant-card-extra .ant-btn:not(.ant-btn-sm):not(.btn-action-round) .anticon,\n.admin-page-header .ant-btn:not(.ant-btn-sm):not(.btn-action-round) .anticon {\n  font-size: 16px;\n}\n\n/* --- Icon-only action buttons (rounded square) ---------------------------- */\n.ant-btn.btn-action-round {\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px !important;\n}\n.ant-btn.btn-action-round.btn-action-danger {\n  color: #d4380d;\n  background: var(--app-danger-soft);\n  border-color: transparent;\n}\n.ant-btn.btn-action-round.btn-action-danger:hover {\n  color: #a8071a;\n  background: #ffd6d6;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
